import { render } from "./IconArrowLeft.vue?vue&type=template&id=5f7b5c08"
import script from "./IconArrowLeft.vue?vue&type=script&lang=ts"
export * from "./IconArrowLeft.vue?vue&type=script&lang=ts"
script.render = render

export default script